import * as React from "react";
import { useMemo, useCallback } from "react";
import { useFormikContext, Field } from "formik";
import { useTranslation } from "react-i18next";
import { Row } from "common/components";
import { FormikSelect, FormikTimezoneSelect, FormikInput } from "security-app/components/common/FormikComponents";
import usePermissions from "hooks/usePermissions";
import { useGetCountryLoc } from "./LocationService/useLocation";
function Step2() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const { t } = useTranslation("enterprise_security_assets");
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const { isPermitted } = usePermissions();
  const canEdit = isPermitted("asset:edit");
  const { countryLocs } = useGetCountryLoc();
  const countryOptions = useMemo(() => {
    if (!countryLocs) return [];
    return countryLocs.map((country) => ({
      value: `${country.name.official}`,
      label: `${country.flag} ${country.name.common}`
    }));
  }, [countryLocs]);
  const onCountryChange = useCallback(
    (selectedCountryName) => {
      const selectedCountry = countryLocs.find(
        (country) => country.name.official === selectedCountryName
      );
      const {
        latlng: [latitude, longitude],
        cca2,
        region,
        subregion
      } = selectedCountry || { latlng: ["", ""], cca2: "", region: "", subregion: "" };
      const getRegionValue = () => {
        let regionValue = region || "";
        if (subregion) regionValue = `${regionValue} - ${subregion}`;
        return regionValue;
      };
      setFieldValue("details.geo_info.country_iso_code", cca2 || "");
      setFieldTouched("details.geo_info.country_iso_code", true);
      setFieldValue("details.geo_info.latitude", latitude || "");
      setFieldTouched("details.geo_info.latitude", true);
      setFieldValue("details.geo_info.longitude", longitude || "");
      setFieldTouched("details.geo_info.longitude", true);
      setFieldValue("details.geo_info.region", getRegionValue());
      setFieldTouched("details.geo_info.region", true);
    },
    [countryLocs, setFieldTouched, setFieldValue]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "details.geo_info.country_name",
      id: "country_name",
      placeholder: t("machine_form_step2.country_name_placeholder"),
      label: t("machine_form_step2.country_name_label"),
      value: (_b = (_a = values.details) == null ? void 0 : _a.geo_info) == null ? void 0 : _b.country_name,
      options: countryOptions,
      onChange: onCountryChange,
      maxMenuHeight: 200,
      menuPlacement: "bottom",
      disabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.geo_info.country_iso_code",
      id: "country_iso_code",
      type: "text",
      label: t("machine_form_step2.country_code_label"),
      value: (_d = (_c = values.details) == null ? void 0 : _c.geo_info) == null ? void 0 : _d.country_iso_code,
      disabled: !canEdit
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.geo_info.city_name",
      id: "city_name",
      type: "text",
      label: t("machine_form_step2.city_name_label"),
      value: (_f = (_e = values.details) == null ? void 0 : _e.geo_info) == null ? void 0 : _f.city_name,
      disabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.geo_info.latitude",
      id: "latitude",
      type: "number",
      label: t("machine_form_step2.latitude_label"),
      value: (_h = (_g = values.details) == null ? void 0 : _g.geo_info) == null ? void 0 : _h.latitude,
      disabled: !canEdit
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.geo_info.longitude",
      id: "longitude",
      type: "number",
      label: t("machine_form_step2.longitude_label"),
      value: (_j = (_i = values.details) == null ? void 0 : _i.geo_info) == null ? void 0 : _j.longitude,
      disabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.geo_info.region",
      id: "region",
      type: "text",
      label: t("machine_form_step2.region_label"),
      value: (_l = (_k = values.details) == null ? void 0 : _k.geo_info) == null ? void 0 : _l.region,
      disabled: !canEdit
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikTimezoneSelect,
      name: "details.geo_info.time_zone",
      id: "time_zone",
      label: t("machine_form_step2.time_zone_label"),
      menuPlacement: "top",
      maxMenuHeight: 200,
      value: (_n = (_m = values.details) == null ? void 0 : _m.geo_info) == null ? void 0 : _n.time_zone,
      disabled: !canEdit
    }
  )));
}
export default Step2;
